import Tippy from "@tippyjs/react";
import {
  Avatar,
  Box,
  Button,
  Header,
  Menu,
  Nav,
  ResponsiveContext
} from "grommet";
import {
  Camera,
  DocumentTest,
  DocumentUser,
  Github,
  Linkedin,
  Menu as MenuIcon,
} from "grommet-icons";
import React, { Component } from "react";
import { Link, Route } from "react-router-dom";
import "tippy.js/animations/perspective.css";
import "tippy.js/dist/tippy.css";

class TopBar extends Component {
  render() {
    return (
      <Header background="brand" pad="small">
        <Box direction="row" align="center" gap="small">
          <Tippy content="Me" animation="perspective">
            <span>
              <Link to="/">
                <Avatar src={`${process.env.PUBLIC_URL}/avatar.jpg`} size="medium" />
              </Link>
            </span>
          </Tippy>
        </Box>
        <ResponsiveContext.Consumer>
          {(responsive) =>
            responsive === "small" ? (
              <Route
                render={({ history }) => (
                  <Menu
                    label="Menu"
                    icon={<MenuIcon />}
                    dropBackground="dark-1"
                    dropProps={{ elevation: "none" }}
                    items={[
                      {
                        label: <Box alignSelf="center">Resume</Box>,
                        href: `${process.env.PUBLIC_URL}/Resume.pdf`,
                        icon: (
                          <Box pad="small">
                            <DocumentUser />
                          </Box>
                        ),
                      },
                      {
                        label: <Box alignSelf="center">Projects</Box>,
                        onClick: () => {
                          history.push("/projects");
                        },
                        icon: (
                          <Box pad="small">
                            <DocumentTest />
                          </Box>
                        ),
                      },
                      {
                        label: <Box alignSelf="center">GitHub</Box>,
                        href: "https://github.com/rpaulucci3",
                        target: "_blank",
                        icon: (
                          <Box pad="small">
                            <Github />
                          </Box>
                        ),
                      },
                      {
                        label: <Box alignSelf="center">LinkedIn</Box>,
                        href: "https://linkedin.com/in/rpaulucci",
                        target: "_blank",
                        icon: (
                          <Box pad="small">
                            <Linkedin />
                          </Box>
                        ),
                      },
                      {
                        label: <Box alignSelf="center">Flickr</Box>,
                        href: "https://www.flickr.com/photos/188560183@N05/",
                        target: "_blank",
                        icon: (
                          <Box pad="small">
                            <Camera />
                          </Box>
                        ),
                      },
                    ]}
                  />
                )}
              />
            ) : (
              <Nav direction="row" gap="none">
                <Tippy content="Resume" animation="perspective">
                  <Button
                    icon={<DocumentUser />}
                    href={`${process.env.PUBLIC_URL}/Resume.pdf`}
                    target="_blank"
                  />
                </Tippy>
                <Tippy content="Projects" animation="perspective">
                  <Link to="/projects">
                    <Button icon={<DocumentTest />} />
                  </Link>
                </Tippy>
                <Tippy content="GitHub" animation="perspective">
                  <Button
                    icon={<Github />}
                    href="https://github.com/rpaulucci3"
                    target="_blank"
                  />
                </Tippy>
                <Tippy content="LinkedIn" animation="perspective">
                  <Button
                    icon={<Linkedin />}
                    href="https://linkedin.com/in/rpaulucci"
                    target="_blank"
                  />
                </Tippy>
                <Tippy content="Flickr" animation="perspective">
                  <Button
                    icon={<Camera />}
                    href="https://www.flickr.com/photos/188560183@N05/"
                    target="_blank"
                  />
                </Tippy>
              </Nav>
            )
          }
        </ResponsiveContext.Consumer>
      </Header>
    );
  }
}

export default TopBar;
